<template>
    <v-overlay class="loading" :value="loading">
        <v-progress-circular
        indeterminate
        color="teal"
        size="64"
        width="5"
        ></v-progress-circular>
    </v-overlay>
</template>

<script>

export default {
  name: 'Loader',
  props: {
    loading: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
  .loading {
    /* background: rgba(10, 10, 10, 0.5); */
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
  }
</style>
